import { Typography, styled } from '@ori-ui/mui';

export const Root = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(1),
}));

export const Brand = styled(Typography)({
  display: '-webkit-box',
  letterSpacing: 2,
  lineHeight: 'normal',
  overflow: 'hidden',
  textAlign: 'left',
  textTransform: 'uppercase',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 1,
  width: '100%',
  '&:empty': { display: 'none' },
});

export const Name = styled(Typography)(({ theme }) => ({
  display: '-webkit-box',
  lineHeight: theme.spacing(4),
  overflow: 'hidden',
  textAlign: 'left',
  WebkitBoxOrient: 'vertical',
  WebkitLineClamp: 2,
  width: '100%',
}));

export const Bottom = styled('div')(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  gap: theme.spacing(2),
  alignItems: 'center',
  flexWrap: 'wrap',
}));
